import NavLinks from "./NavLinks";

const MobileNavigation = ({ open, setIsOpen, isLoggedIn, user }) => {
  return (
    <div
      className={`lg:hidden w-full absolute left-0 top-full bg-white shadow-md transition-all duration-300 ease-in-out overflow-hidden z-40 ${
        open ? "max-h-screen opacity-100 border-t border-gray-100" : "max-h-0 opacity-0"
      }`}
    >
      <div className="px-4 pb-4 bg-white">
        <NavLinks close={setIsOpen} isLoggedIn={isLoggedIn} user={user} />
      </div>
    </div>
  );
};

export default MobileNavigation;
